import React from "react";

import ShareWithDetails from "../../../SharedWith/SharedWithDetails/SharedWithDetails";
const profileWithName = (props) => (
  <div className="d-flex">
    <ShareWithDetails
      key={props.key}
      sKey={props.sKey}
      isPopover={props.isPopover}
      nameIntial={props.nameIntial}
      personName={props.personName}
      profile={props.profile}
      role={props.role}
    />
    <div className="text-col-2 ml-3" style={{ cursor: "default" }}>
      {props.personName}
    </div>
  </div>
);

export default profileWithName;
